import "../styles.scss";

import ReactDOM from "react-dom";
import { FlagIcon } from "react-flag-kit";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import TableLogPush from "../TableLogPush";
import ModalSendPush from "../modalSendPush";
import { SCButtonAddInput } from "../../../../components/Buttons/styles";
import { getLogMessagePush, getMessagePush, postMessagePush } from "../../../../store/middleware";

function CRUDPushGenerator() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [id, setId] = useState(0);
  const [allLog, setAllLog] = useState([]);
  const [allPush, setAllPush] = useState([]);
  const [modalSend, setModalSend] = useState(false);
  const [detailLog, setDetailLog] = useState(false);
  const [pushTitleEN, setPushTitleEN] = useState("");
  const [pushTitleES, setPushTitleES] = useState("");
  const [pushTitleFR, setPushTitleFR] = useState("");
  const [pushTitlePT, setPushTitlePT] = useState("");
  const [detailPush, setDetailPush] = useState(false);
  const [pushContentEN, setPushContentEN] = useState("");
  const [pushContentES, setPushContentES] = useState("");
  const [pushContentFR, setPushContentFR] = useState("");
  const [pushContentPT, setPushContentPT] = useState("");
  const [formModal, setFormModal] = useState({
    group: "",
    messageId: 0,
    specificFilter: "",
  });

  const getData = () => {
    dispatch(getMessagePush()).then((res) => res && setAllPush(res));
  };

  const handleGetLog = (id) => {
    setDetailLog(true);
    dispatch(getLogMessagePush(id)).then((res) => setAllLog(res));
  };

  const openModalSend = (id) => {
    setModalSend(true);
    setFormModal((state) => ({ ...state, messageId: id }));
  };

  const handleSaveDetail = () => {
    try {
      if (!pushTitleEN || !pushTitleES || !pushTitlePT || !pushTitleFR) return;

      const body = {
        titleEn: pushTitleEN,
        titleEs: pushTitleES,
        titlePt: pushTitlePT,
        titleFr: pushTitleFR,
        messageEn: pushContentEN,
        messageEs: pushContentES,
        messageFr: pushContentFR,
        messagePt: pushContentPT,
      };

      dispatch(postMessagePush(body));
    } catch (e) {
      console.log(e);
    }

    setTimeout(() => {
      setDetailPush(false);
    }, 1000);
  };

  const resetState = () => {
    setId("");
    setPushTitleEN("");
    setPushTitleES("");
    setPushTitlePT("");
    setPushTitleFR("");
    setPushContentEN("");
    setPushContentES("");
    setPushContentPT("");
    setPushContentFR("");
  };

  const handleOpenDetail = async (item, type) => {
    if (type === "add") {
      resetState();
      setDetailPush(true);
    } else {
      if (item) {
        setId(item.id);
        setPushTitleEN(item.titleEn);
        setPushTitleES(item.titleEs);
        setPushTitlePT(item.titlePt);
        setPushTitleFR(item.titleFr);
        setPushContentEN(item.messageEn);
        setPushContentES(item.messageEs);
        setPushContentPT(item.messagePt);
        setPushContentFR(item.messageFr);
      } else {
        resetState();
      }

      setDetailPush(true);
    }
  };

  const handleDelete = (id) => {
    console.log(id);
    // dispatch(deleteDisclosureAffiliate(id)).then(() => setDetailPush(false));
  };

  const renderButtonRight = () => (
    <button className="buttonRight" onClick={() => handleOpenDetail(null, "add")}>
      <i className="fa fa-plus" aria-hidden="true" />
      Add new Push
    </button>
  );

  useEffect(() => {
    getData();
    ReactDOM.render(renderButtonRight(), document.getElementById("renderButtonPush"));
    // eslint-disable-next-line
  }, [detailPush]);

  return !detailPush ? (
    <>
      {!detailLog ? (
        <div className="bigBoxTable">
          <table>
            <tbody>
              <tr>
                <th>{t("TITLE")}</th>
                <th style={{ textAlign: "center" }}>{t("OPTIONS")}</th>
              </tr>

              {allPush.length > 0 &&
                allPush.map((item) => (
                  <tr key={item.id}>
                    <td>{item.titleEn}</td>
                    <td>
                      <div className="wrapperButtons">
                        <button onClick={() => handleGetLog(item.id)}>
                          Log <i className="fa fa-plus" aria-hidden="true" />
                        </button>
                        <button onClick={() => openModalSend(item.id)}>
                          {t("SEND")} <i className="fa fa-paper-plane" aria-hidden="true" />
                        </button>
                        <button onClick={() => handleOpenDetail(item, "")}>
                          {t("BTN_VIEW")} <i className="fa fa-angle-right" aria-hidden="true" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      ) : (
        <TableLogPush allLog={allLog} setDetailLog={setDetailLog} />
      )}

      <ModalSendPush modalSend={modalSend} setModalSend={setModalSend} form={formModal} setForm={setFormModal} />
    </>
  ) : (
    <div className="contentDetailPush">
      <div className="header">
        <div className="divLeft">
          {id ? (
            <SCButtonAddInput style={{ display: "none" }} name="remove" onClick={() => handleDelete(id)}>
              {t("DELETE")} <i className="fa fa-times-circle-o fa-lg"></i>
            </SCButtonAddInput>
          ) : null}
        </div>

        <div className="wrapperButtons">
          <button onClick={() => setDetailPush(false)}>{t("BACK")}</button>
          {!id && <button onClick={handleSaveDetail}>{t("SAVE")}</button>}
        </div>
      </div>

      <div>
        <div className="wrapperTitle">
          <FlagIcon size={35} code={"US"} />
          <h1 className="titleEditor">{t("BTN_ENGLISH")}</h1>
        </div>

        <div className="wrapperNameMenu">
          <div className="wrapperName">
            <label>{t("TITLE")}</label>
            <input type="text" maxLength={65} value={pushTitleEN} onChange={(e) => setPushTitleEN(e.target.value)} />
          </div>
        </div>

        <textarea
          rows={8}
          maxLength={150}
          className="textarea"
          value={pushContentEN}
          onChange={(e) => setPushContentEN(e.target.value)}
        />

        <div className="wrapperTitle mt_30">
          <FlagIcon size={35} code={"ES"} />
          <h1 className="titleEditor mt-20">{t("BTN_SPANISH")}</h1>
        </div>

        <div className="wrapperNameMenu">
          <div className="wrapperName">
            <label>{t("TITLE")}</label>
            <input type="text" maxLength={65} value={pushTitleES} onChange={(e) => setPushTitleES(e.target.value)} />
          </div>
        </div>

        <textarea
          rows={8}
          maxLength={150}
          className="textarea"
          value={pushContentES}
          onChange={(e) => setPushContentES(e.target.value)}
        />

        <div className="wrapperTitle mt_30">
          <FlagIcon size={35} code={"BR"} />
          <h1 className="titleEditor mt-20">{t("BTN_PORTUGUESE")}</h1>
        </div>

        <div className="wrapperNameMenu">
          <div className="wrapperName">
            <label>{t("TITLE")}</label>
            <input type="text" maxLength={65} value={pushTitlePT} onChange={(e) => setPushTitlePT(e.target.value)} />
          </div>
        </div>

        <textarea
          rows={8}
          maxLength={150}
          className="textarea"
          value={pushContentPT}
          onChange={(e) => setPushContentPT(e.target.value)}
        />

        <div className="wrapperTitle mt_30">
          <FlagIcon size={35} code={"FR"} />
          <h1 className="titleEditor mt-20">{t("FRENCH")}</h1>
        </div>

        <div className="wrapperNameMenu">
          <div className="wrapperName">
            <label>{t("TITLE")}</label>
            <input type="text" maxLength={65} value={pushTitleFR} onChange={(e) => setPushTitleFR(e.target.value)} />
          </div>
        </div>

        <textarea
          rows={8}
          maxLength={150}
          className="textarea"
          value={pushContentFR}
          onChange={(e) => setPushContentFR(e.target.value)}
        />
      </div>
    </div>
  );
}

export default CRUDPushGenerator;
